<template>
    <div v-if="commLogs && channels" class="container-fluid">
        <div v-for="log in commLogs" :key="log.id" class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <span class="card-datetime">
                            <span class="fw-bold">Subject:</span> {{ commReasons.find(obj => obj.id == log.comm_reason_id).name }}
                        </span>
                        <span class="card-datetime">
                            <span class="fw-bold">Date & Time:</span> {{ formatDate(log.date) }} at {{ formatTime(log.time) }}
                        </span>
                        <span>
                            <button v-if="canEdit(log)" class="btn btn-primary btn-sm" title="Edit" @click="openCommLogModal(log)"><i class="bi-pencil"></i></button>
                            <button v-if="canDelete(log)" class="btn btn-danger btn-sm ms-2" title="Delete" @click="deleteCommLog(log)"><i class="bi-trash"></i></button>
                        </span>
                    </div>
                    <div class="card-body">
                        <div class="row mb-1">
                            <div class="col-2 fw-bold text-end">Status</div>
                            <div class="col-9 mb-0">{{ commStatuses.find(obj => obj.id == log.comm_status_id).name }}</div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-2 fw-bold text-end">Channel</div>
                            <div class="col-9">{{ log.channel.name }} &ndash; {{ channels.find(obj => obj.id == log.channel.id).address }}</div>
                        </div>
                        <div class="row">
                            <div class="col-2 fw-bold text-end">Notes</div>
                            <div class="col-9">{{ log.notes }}</div>
                        </div>
                    </div>
                </div><!-- .card -->
            </div>
            <div class="col">
                
            </div>
        </div>
        <comm-log-modal ref="commLogModal"></comm-log-modal>
    </div>
</template>

<style scoped>
    .card-datetime {
        font-size: 1.1em;
        padding-top: 5px;
        margin-bottom: 0;
    }
</style>


<script setup>
    import { ref } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useCommLogsStore } from '../../stores/comm-logs-store'
    import CommLogModal from './CommLogModal.vue'
    import moment from 'moment'

    const { commLogs, commLog, commReasons, commStatuses, channels, user, error } = storeToRefs(useCommLogsStore())
    const { setUpdater, setRecipient, setCommReasons, setCommStatuses, fetchCommLogs, fetchChannels, setCommLog, deleteCommLog } = useCommLogsStore()
    const props = defineProps(['updater', 'updaterRoles', 'updaterType', 'recipient', 'recipientType', 'commReasons', 'commStatuses'])

    setUpdater(props.updater, props.updaterRoles, props.updaterType)
    setRecipient(props.recipient, props.recipientType)
    setCommReasons(props.commReasons)
    setCommStatuses(props.commStatuses)

    fetchCommLogs()
    fetchChannels()

    function canDelete (log) {

        const hasConsultantRole = user.value.roles.some(obj => obj.name === 'Consultant');
        const hasInterviewTeamRole = user.value.roles.some(obj => obj.name === 'Interview Team');

        if ((hasConsultantRole || hasInterviewTeamRole) && log.sender_id != user.value.id) {
            return false
        }
        return true
    }

    function canEdit (log) {

        const hasConsultantRole = user.value.roles.some(obj => obj.name === 'Consultant');
        const hasInterviewTeamRole = user.value.roles.some(obj => obj.name === 'Interview Team');

        if ((hasConsultantRole || hasInterviewTeamRole) && log.sender_id != user.value.id) {
            return false
        }
        return true
    }

    function formatDate (date) { 
        return date ? moment(date).format('MM/DD/YYYY') : null
    } 
    function formatTime (time) { 
        return time ? moment(time, "HH:mm:ss").format('h:mm a') : null
    }

    // open modal to manage channels
    let commLogModal = ref(null);
    function openCommLogModal (log) {
        setCommLog(log)
        commLogModal.value.show()
    }
</script>